<template>
    <div class="doc_container">
        <div>
            <h2 style="margin-top:0pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">事業者名</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">株式会社Yostar</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">所在地</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">東京都千代田区神田練塀町３００番住友不動産秋葉原駅前ビル１１階</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">代表者名</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">李 衡達</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">お問い合わせ先</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">電話番号：03-5846-8348</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">FAX：03-5846-8349</span>
            </p>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:12pt">
                <span style="font-family:Meiryo; font-size:11pt">メールアドレス：</span>
                <a href="mailto:cs_jp@mahjongsoul.com" style="text-decoration:none">
                    <span style="font-family: inherit; color:#000000">cs@mahjongsoul.com</span>
                </a>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">販売価格</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">購入画面に記載（表示価格は消費税を含みます）。</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">お支払い方法</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <a
                    href="http://www.dmm.com/top/point/"
                    target="_blank"
                    style="text-decoration:none"
                >
                    <span style="font-family: inherit; color:#000000">DMMポイント</span>
                </a>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">販売価格以外にご負担いただく費用</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">ウェブサイト</span>
                <span style="font-family:Meiryo">をご利用いただくために必要なインターネット接続環境、ソフトウェア、通信料金等はお客様の負担となります。</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">支払時期</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">購入ボタンを押した時点</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">送料</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">インターネット上の商品のため、送料は発生いたしません。</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">商品等の引渡、デジタルコンテンツ等の利用が可能になる時期</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">購入に関するページに特別な定めを置いている場合を除き、購入取引完了後、直ちにご利用いただけます。</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">キャンセル・返品</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">デジタルアイテム等購入後のお客様のご都合によるキャンセルは、お受けできません。</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">免責事項</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span
                    style="font-family:Meiryo"
                >弊社は、サーバトラブル、ネットワークトラブルその他不可抗力により生じたサービス・商品の提供不能、中断等については一切その責任を負わないものとします。</span>
            </p>
            <h2 style="margin-top:14pt; margin-bottom:14pt">
                <span style="font-family:Meiryo">特別条件 販売条件</span>
            </h2>
            <p style="margin-top:0pt; margin-bottom:0pt; font-size:11pt">
                <span style="font-family:Meiryo">ご購入者様が未成年者の場合は、保護者の方の同意を得てからご購入ください。</span>
            </p>
            <p
                style="margin-top:0pt; margin-bottom:0pt; text-align:justify; widows:0; orphans:0; font-size:10.5pt"
            >
                <span style="font-family: inherit">&#xa0;</span>
            </p>
        </div>
    </div>
</template>

<script>
export default {
    data: () => ({}),
    mounted() {
        document.dispatchEvent(new Event("custom-render-trigger"));
    }
};
</script>

<style lang="scss" scoped>
.doc_container {
    width: 60%;
    margin: 50px auto;

    h2 {
        font-size: pxTorem(20px) !important;
    }

    @media screen and (max-width: 600px) {
        width: 90%;

        h2 {
            font-size: MpxTorem(20px) !important;
        }
    }
}
</style>